const figmaFileIdRegex = /^[0-9a-zA-Z]{22,128}$/;
const nodeIdRegex = /^\d+-\d+$/;
const nodeTypeRegex = /^[0-9a-zA-Z]^/;
export var ParsedFigmaFileURLError;
(function (ParsedFigmaFileURLError) {
    ParsedFigmaFileURLError["InvalidUrl"] = "InvalidUrl";
    ParsedFigmaFileURLError["InvalidFigmaFileId"] = "InvalidFigmaFileId";
})(ParsedFigmaFileURLError || (ParsedFigmaFileURLError = {}));
export const FigmaUtils = {
    tryParseFigmaFileURL(urlString) {
        if (!URL.canParse(urlString)) {
            return { status: "Error", error: ParsedFigmaFileURLError.InvalidUrl };
        }
        // Validate that this is a Figma URL
        const url = new URL(urlString);
        if (!url.hostname.endsWith("figma.com")) {
            return { status: "Error", error: ParsedFigmaFileURLError.InvalidUrl };
        }
        // Validate that the URL type is the correct one (pointing to a design file)
        const pathSegments = url.pathname.split("/");
        if (pathSegments[1] !== "design" && pathSegments[1] !== "file") {
            return { status: "Error", error: ParsedFigmaFileURLError.InvalidUrl };
        }
        // Validate Figma file ID
        const fileId = pathSegments[2];
        if (!fileId || !fileId.match(figmaFileIdRegex)) {
            return {
                status: "Error",
                error: ParsedFigmaFileURLError.InvalidFigmaFileId,
            };
        }
        // Parse Figma file name
        let fileName = null;
        const rawFileName = pathSegments[3];
        if (rawFileName) {
            fileName = rawFileName.replaceAll("-", " ");
        }
        // Parse node id
        let nodeId = null;
        const nodeIdRaw = url.searchParams.get("node-id");
        if (nodeIdRaw && nodeIdRaw.match(nodeIdRegex)) {
            nodeId = nodeIdRaw.replace("-", ":");
        }
        // Parse node type
        let nodeType = null;
        const nodeTypeRaw = url.searchParams.get("node-type");
        if (nodeTypeRaw && nodeTypeRaw.match(nodeTypeRegex)) {
            nodeType = nodeTypeRaw;
        }
        return { status: "Success", fileId, fileName, nodeId, nodeType };
    },
};
// https://www.figma.com/design/U3Mg3I8WbvqF6CcZtRJM7w?node-id=2-3&t=9Qev2vhsldyFMhuE-1
